export const loginLink = '/login';

export const homeLink = '/home';

export const signupLink = '/signup';

export const mainLink = '/';

export const appendAdLink = '/append';

export const successAppendLink = '/success';

export const catalogLink = '/catalog'

export const adLink = '/ad'

export const newsLink = '/news'
